import axiosInstance from '../lib/axios';

export interface ReportFilters {
  from_date?: string;
  to_date?: string;
  user_id?: number;
}

export interface ReportParams extends ReportFilters {
  page?: number;
  limit?: number;
}

export const reportService = {
  getDocumentsReport: (params: ReportParams = {}) =>
    axiosInstance.get('/reports/documents', { params }),

  exportDocumentsReport: (params: ReportFilters = {}) =>
    axiosInstance.get('/reports/documents/export', { params, responseType: 'blob' }),

  getUploaders: () => axiosInstance.get('/reports/uploaders'),
};

export default reportService;
